import React from 'react';
import configData from '../../config.json';
import DoneIcon from '../../Assets/img/DoneIcon.svg';
import LockIcon from '../../Assets/img/LockIcon.svg';
import '../Dashboard/ELearningBoard/Board/ELearningCard.css';

/** Static E-Learning card — V1 markup, no navigation. */
const MarketingELearningCard = ({ item, showLeftBorder }) => {
    const imagePath = String(item.imagePath || '').replace(/^\//, '');
    const urlImage = `url("${configData.SERVER_URL_IMG}${imagePath}")`;

    return (
        <article
            className="eLearningCard"
            style={{ backgroundImage: urlImage, pointerEvents: 'none' }}
        >
            {!item.isUnlocked && (
                <div className="eLearningCard__dark">
                    {item.unLockDateText ? (
                        <p className="paragraph-3 unlockDateContainer">
                            <b>
                                Unlocks On: <br />
                                {item.unLockDateText}
                            </b>
                        </p>
                    ) : null}
                </div>
            )}
            <div className="eLearningCard__cardText">
                <p className="paragraph-3">{item.title}</p>
            </div>
            {item.isUnlocked ? (
                item.isCompleted && (
                    <img className="doneIcon" src={DoneIcon} alt="Done" />
                )
            ) : (
                <img className="lockIcon" src={LockIcon} alt="Locked" />
            )}
            {showLeftBorder ? <span aria-hidden /> : null}
        </article>
    );
};

export default MarketingELearningCard;
